/**
 * @file birthdate.js
 * Handles the logic for the birthdate selection and zodiac calculation.
 */

import { getChineseZodiac, thaiMonths } from "./zodiac.js";
import { updateValidDays, updateValidMonths } from "./utils.js";

const birthDaySelect = document.getElementById("birth_day");
const birthMonthSelect = document.getElementById("birth_month");
const birthYearSelect = document.getElementById("birth_year");

/**
 * Populates the birth day and year dropdowns.
 */
function populateBirthdateDropdowns() {
  for (let day = 1; day <= 31; day++) {
    const option = document.createElement("option");
    option.value = day;
    option.textContent = day;
    birthDaySelect.appendChild(option);
  }

  const currentYear = new Date().getFullYear();
  const currentBuddhistYear = currentYear + 543;

  for (let i = 0; i <= 120; i++) {
    const buddhistYear = currentBuddhistYear - i;
    const gregorianYear = buddhistYear - 543;
    const option = document.createElement("option");
    option.value = gregorianYear;
    option.textContent = buddhistYear;
    birthYearSelect.appendChild(option);
  }
}

/**
 * Validation rule for birth dates. Returns true if the date is in the future.
 */
function isInvalidBirthDate(date) {
  return date > new Date();
}

/**
 * Updates the hidden birth date field and the Chinese zodiac field.
 */
function updateBirthDate() {
  const hiddenBirthDate = document.getElementById("hidden_birth_date");
  const zodiacInput = document.getElementById("chinese_zodiac");

  const day = birthDaySelect.value;
  const month = birthMonthSelect.value;
  const year = birthYearSelect.value;

  if (day && month && year) {
    const buddhistYear = parseInt(year) + 543;
    const monthName = thaiMonths[parseInt(month)];
    hiddenBirthDate.value = `${day} ${monthName} ${buddhistYear}`;
    zodiacInput.value = getChineseZodiac(parseInt(year));
  } else {
    hiddenBirthDate.value = "";
    zodiacInput.value = "";
  }
}

function handleDateChange() {
  const year = parseInt(birthYearSelect.value);
  const month = parseInt(birthMonthSelect.value);

  if (year) {
    updateValidMonths(birthMonthSelect, year, isInvalidBirthDate);
  }
  if (year && month) {
    updateValidDays(birthDaySelect, month, year, isInvalidBirthDate);
  }

  updateBirthDate();
}

/**
 * Initializes the birthdate form.
 */
export function initBirthdateForm() {
  if (!birthDaySelect || !birthMonthSelect || !birthYearSelect) return;

  // Clear previous options if re-initializing
  birthDaySelect.innerHTML = '<option value="" disabled selected>วัน</option>';
  birthYearSelect.innerHTML = '<option value="" disabled selected>ปี</option>';

  populateBirthdateDropdowns();
  handleDateChange();

  [birthYearSelect, birthMonthSelect, birthDaySelect].forEach((el) =>
    el.addEventListener("change", handleDateChange)
  );
}
